import React from 'react'
import { useTranslation } from 'react-i18next';
import { Ticket } from '../../../../../models/Ticket';
import { Exercise } from '../../../../../models/Exercise';
import SingleReservation from '../../ReservationsTab/SingleReservation';
import { isAfter, startOfDay } from "date-fns";

interface IProps {
  pass: Ticket;
  onRefreshTickets?: () => void;
}

const DetailsExercises: React.FC<IProps> = ({ pass, onRefreshTickets }) => {
  const { t } = useTranslation();

  // Filtrujemy tylko nadchodzące rezerwacje (od dzisiaj 00:00 w przyszłość)
  const getUpcomingExercises = (): Exercise[] => {
    if (!pass.exercises || pass.exercises.length === 0) {
      return [];
    }

    const today = startOfDay(new Date());
    return pass.exercises.filter((exercise) => {
      const exerciseDate = new Date(exercise.startTime);
      return isAfter(exerciseDate, today) || exerciseDate.getTime() === today.getTime();
    });
  };

  const upcomingExercises = getUpcomingExercises();

  return (
    <div className="ticket-details__exercises-section">
      <h5>
        {t("nadchodzace_rezerwacje")} ({upcomingExercises.length})
      </h5>

      {upcomingExercises.length > 0 ? (
        <div className="ticket-details__exercises-list">
          {upcomingExercises.map((exercise, index) => (
            <div key={index} className="ticket-details__exercise-item">
              <SingleReservation
                ticket={pass}
                exercise={exercise}
                onRefreshTickets={onRefreshTickets}
                variant="minimal"
              />
            </div>
          ))}
        </div>
      ) : (
        <p className="body-text-small text-color-light-gray">{t("brak_nadchodzacych_rezerwacji")}</p>
      )}

      {/* Podsumowanie pozostałych zapisów
      <EAAlert type="success" message={`${t("pozostalo_do_wykorzystania")}: ${remainingEntrances}/${pass.entrances}`} /> */}
    </div>
  );
};

export default DetailsExercises;
